import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import "./styles/ListaLogs.css";
import "./styles/estandar/ButtonStyles.css"
import MenuBar from "../components/MenuBar";
import { validatePropertyDeps } from "ajv/dist/vocabularies/applicator/dependencies";
import Cookies from 'js-cookie';
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaChevronCircleDown } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import axios from "axios";
import { useConfig } from '../contexts/ConfigContext';

//Confurado para prodA
const ListaLogs = () =>{
    const config = useConfig();
    const API_URL = `${config.API_URL}/api/usuario/`;

    
    const [reiniciarPagina, setReiniciarPagina] = useState(false);
    const [paginaActual, setPaginaActual] = useState(0);
    const [paginaTamano, setPaginaTamano] = useState(0);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [totalPaginas, setTotalPaginas] = useState(0);
    const [items, setItems] = useState([]);


    const [totalRegCargados, setTotalRegCargados] = useState(0);

    const [genericMensajeError, setGenericMensajeError] = useState('');
    const [showMensajeError, setShowMensajeError] = useState(false);
    


    const navigate = useNavigate();

    //Campo busqueda
    const [buscar, setBuscar] = useState('');
    
    const [admin, setAdmin] = useState(false);
    const validarSesion = () =>{
            if(Cookies.get("turid")){
                const turid = Cookies.get("turid");
                if(turid === "rid1"){
                    setAdmin(true);
                }else{
                    navigate("/");
                    Cookies.remove("usr");
                    Cookies.remove("turid");
                }
            }else{
                navigate("/");
                Cookies.remove("usr");
            }
    }
    useEffect(() =>{
        validarSesion();

        const JSONPagina = {
            "paginaActual": 0,
            "paginaTamano": 0,
            "totalRegistros": 0,
            "totalPaginas": 0,
            "registroList": []
        }

        //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );

        const inicializarLogs = async () =>{
            try{
                const response = await axios.post(API_URL + "cargar_logs", JSONPagina, {Authorization: true});
                const JSONResumen = response.data;
                setPaginaActual(JSONResumen["paginaActual"]);
                setPaginaTamano(JSONResumen["paginaTamano"]);
                setTotalRegistros(JSONResumen["totalRegistros"]);
                setTotalPaginas(JSONResumen["totalPaginas"]);
                setItems(JSONResumen.logs);

                const regCargados = JSONResumen["paginaTamano"] * JSONResumen["paginaActual"];

                if(JSONResumen["totalRegistros"] === 0){
                    setTotalRegCargados(0);
                }else{
                    if(regCargados < JSONResumen["totalRegistros"]){
                    setTotalRegCargados(regCargados);
                    }else{
                        setTotalRegCargados(JSONResumen["totalRegistros"]);
                    }
                }


            }catch(error){
                console.log(error);
                setGenericMensajeError("Ha ocurrido un error al cargar los logs: "+error);
                setShowMensajeError(true);

            }
        };

        inicializarLogs();
        
        

    },[]);

    const handleCargarPaginas = async(e) =>{
        e.preventDefault();
        if(paginaActual === totalPaginas){
            return null;
        }

             //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );

        var nuevaPagina = paginaActual + 1;

        const JSONPagina = {}
        var link_API = "";

        if(buscar === ''){
                JSONPagina = {
            "paginaActual": nuevaPagina,
            "paginaTamano": 0,
            "totalRegistros": 0,
            "totalPaginas": 0,
            "registroList": []
            }

            link_API = API_URL + "cargar_logs";
        }else{
                 JSONPagina = {
            "paginaActual": nuevaPagina,
            "paginaTamano": 0,
            "totalRegistros": 0,
            "totalPaginas": 0,
            "valor":buscar,
            "registroList": []
            }
            link_API = API_URL + "buscar_logs";
        }

        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );

        try{
            const response = await axios.post(link_API, JSONPagina, {Authorization: true});
            const JSONResumen = response.data;
            setPaginaActual(JSONResumen["paginaActual"]);
            setPaginaTamano(JSONResumen["paginaTamano"]);
            setTotalRegistros(JSONResumen["totalRegistros"]);
            setTotalPaginas(JSONResumen["totalPaginas"]);
            setItems(JSONResumen.logs);

            const regCargados = JSONResumen["paginaTamano"] * JSONResumen["paginaActual"];

            if(JSONResumen["totalRegistros"] === 0){
                setTotalRegCargados(0);
            }else{
                if(regCargados < JSONResumen["totalRegistros"]){
                setTotalRegCargados(regCargados);
                }else{
                    setTotalRegCargados(JSONResumen["totalRegistros"]);
                }
            }


        }catch(error){
            console.log(error);
            setGenericMensajeError("Ha ocurrido un error al cargar los logs: "+error);
            setShowMensajeError(true);

        }





        
    }

    const handleBuscar = async() =>{
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        });
         var nuevaPagina = 0;

        const JSONPagina = {
            "paginaActual": nuevaPagina,
            "paginaTamano": 0,
            "totalRegistros": 0,
            "totalPaginas": 0,
            "valor":buscar,
            "registroList": []
        }


        try{
                const response = await axios.post(API_URL + "buscar_logs", JSONPagina, {Authorization: true});
                const JSONResumen = response.data;
                setPaginaActual(JSONResumen["paginaActual"]);
                setPaginaTamano(JSONResumen["paginaTamano"]);
                setTotalRegistros(JSONResumen["totalRegistros"]);
                setTotalPaginas(JSONResumen["totalPaginas"]);
                setItems(JSONResumen.logs);

                const regCargados = JSONResumen["paginaTamano"] * JSONResumen["paginaActual"];

                if(JSONResumen["totalRegistros"] === 0){
                    setTotalRegCargados(0);
                }else{
                    if(regCargados < JSONResumen["totalRegistros"]){
                    setTotalRegCargados(regCargados);
                    }else{
                        setTotalRegCargados(JSONResumen["totalRegistros"]);
                    }
                }


            }catch(error){
                console.log(error);
                setGenericMensajeError("Ha ocurrido un error al cargar los logs: "+error);
                setShowMensajeError(true);

            }

    }

    const handleGoHome = () =>{
        navigate("../home");
    }

    return(
    <div className="LL-mainHomeBox">
        <MenuBar pagina="adminPanel" sesion={admin}/>
        <div className="LL-mainHomeBody">
            <h1>Historial de cambios</h1>
            <div className="LL-containerTable">
                <button onClick={handleGoHome} id="LL-back" className="buttonStandartGreen"><IoMdArrowRoundBack size="18px"/> Regresar</button>
                <div>
                    <form onSubmit={(e)=>{e.preventDefault(); handleBuscar()}} id="LL-Busqueda">
                        <label className="labelF">Busqueda:</label>
                        <input className="inputF" value={buscar} onChange={(e)=>setBuscar(e.target.value)}/>
                        <button className="buttonStandart" type="submit"> <FaSearch /> Buscar</button>
                    </form>
                </div>
                <table className="LL-table">
                    <thead className="encabezadosRelacion">
                        <tr>
                            <th>ID</th>
                            <th>Usuario</th>
                            <th>Accion</th>
                            <th>Hora</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item)=>(
                            <tr key={item.id_log} className="registroRelacion">
                                <td>{item.id_log}</td>
                                <td>{item.usuario}</td>
                                <td>{item.accion}</td>
                                <td>{item.hora}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {paginaActual !== totalPaginas && <button id="LL-lodBton" onClick={handleCargarPaginas}><FaChevronCircleDown size="18px"/></button>}
                

            </div>
        </div>
    </div>
    );
}

export default ListaLogs;